exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=checkbox] {\n  transform: scale(2);\n  -ms-transform: scale(2);\n  -webkit-transform: scale(2);\n  padding: 10px;\n  margin: 5px; }\n\ninput:hover {\n  cursor: pointer; }\n\n.salary-list li {\n  width: 100%;\n  display: block;\n  margin-bottom: 20px;\n  padding: 8px 6px; }\n  .salary-list li.active {\n    background: #f8fafb; }\n\n.salary-list a:hover {\n  cursor: pointer;\n  color: blue; }\n\n.view-payslip {\n  background: #f8fafb;\n  padding: 10px 10px;\n  border-right: 15px solid white; }\n\n.li-active {\n  color: blue; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/payroll/payroll.component.scss
// module id = ../../../../../src/app/hrms/payroll/payroll.component.scss
// module chunks = main